<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-16",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 16,
      // nextPage: '/questionnaire/section1/17',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'normalBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/Lactation.png'),
        mainTitle: 'Do you know Kegal Exercise?',
        btn: [
          [
            {
              text: 'Yes',
              link: '/questionnaire/section1/17'
            },{
              text: 'No',
              link: '/questionnaire/section2'
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
